import {updateTemplateDescriptionRequest} from '../../actions/docTemplates'
import store from '../../store'

export function updateTemplateDescription(templateId,description){
	return store.dispatch(updateTemplateDescriptionRequest(templateId,description))
}
